export const MAX_SERIES_TO_SHOW = 8
export const MAX_MAIN_SERIES_TO_SHOW = 5

export enum GRAPH_TYPE {
  COLUMN = 'column',
  LINE = 'line',
  RAW = 'raw',
  SPLINE = 'spline',
  STACKED_COLUMN = 'stacked_column',
  STACKED_COLUMN_PERCENT = 'stacked_column_percent',
}

export const breakdownOptions = [
  { label: 'ABTest', value: 'abtest' },
  { label: 'DAI', value: 'dai' },
  { label: 'Device Category', value: 'device_category' },
  { label: 'Device Type', value: 'device_type' },
  { label: 'DSv3', value: 'dsv3' },
  { label: 'Install App Version', value: 'installation_app_version' },
  { label: 'Installation Country', value: 'installation_country' },
  { label: 'UA Source', value: 'ua_source' },
  { label: 'User Type', value: 'user_type' },
]

export const businessReportsBreakdownOptions = [
  { label: 'App Key', value: 'app_key' },
  { label: 'Country', value: 'country' },
  { label: 'Device Type', value: 'device_type' },
]
